import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import {
  ActivityIcon,
  ArrowLeftRightIcon,
  Clock,
  DollarSignIcon,
} from "lucide-react";
import { useOfficeRecord } from "@/app/Offices/Hooks/useOfficeRecord";
import { useOfficeActions } from "@/app/Offices/Hooks/useOfficeActions";
import { Badge } from "@/components/catalyst/badge";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "@tanstack/react-router";

export function OfficeRecordScreen() {
  const office = useOfficeRecord();
  const getActions = useOfficeActions();
  const { hasSupplier } = useGlobalSupplier();

  return (
    <RecordScreen
      tabParams={{ id: office.id }}
      title={office.name}
      breadcrumbs={
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink
                from="/$tenant/$orgId/supplier/{-$supplierId}"
                to="/$tenant/$orgId/supplier/{-$supplierId}/settings"
                params={(prev) => prev}
                search={{ supplier: office.supplier.id }}
              >
                {office.supplier.name}
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink
                from="/$tenant/$orgId/supplier/{-$supplierId}"
                to="/$tenant/$orgId/supplier/{-$supplierId}/offices"
                params={(prev) => prev}
              >
                Offices
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{office.name}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      }
      badges={
        <>
          {!hasSupplier ? (
            <Badge color="zinc">
              <Link
                className="underline"
                from="/$tenant/$orgId/supplier/{-$supplierId}"
                to="/$tenant/$orgId/supplier/{-$supplierId}/settings"
                params={(prev) => prev}
                search={{ supplier: office.supplier.id }}
              >
                {office.supplier.name}
              </Link>
            </Badge>
          ) : null}
          {office.archived_at ? <Badge color="purple">archived</Badge> : null}
        </>
      }
      actionsGroups={getActions(office)}
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/offices/$id",
          Icon: DocumentTextIcon,
        },
        {
          name: "Open hours",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/offices/$id/open-hours",
          Icon: Clock,
        },
        {
          name: "Relocations",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/offices/$id/relocations",
          Icon: ArrowLeftRightIcon,
        },
        {
          name: "Bookings",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/offices/$id/bookings",
          Icon: DollarSignIcon,
        },
        {
          name: "Activity",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/offices/$id/activity",
          Icon: ActivityIcon,
        },
      ]}
    />
  );
}
